/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/arrow-down-3': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path d="M22.3359 6.97501L12.4869 16.8231C12.2182 17.0923 11.7818 17.0923 11.5131 16.8231L1.66406 6.97501" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
